module.exports = __webpack_public_path__ + "static/media/e2.fa980c09.png";